<div
  class="mainContainer d-flex flex-column align-items-center w-100 position-relative mb-5"
>
  <h3 class="headingBL mb-3">
    Simplify Teaching. <span>Amplify Learning</span>
  </h3>
  <p class="vtext Insight_detail">
    Empower educators with intuitive technology that reduces classroom
    complexity and enhances student engagement. From interactive panels loaded
    with K–12 content to all-in-one PCs and smart accessories, our solutions are
    designed to streamline instruction and elevate every learning moment.
  </p>
</div>
<div class="container py-4 mb-5">
  <div class="row justify-content-center gy-4">
    <div
      class="col-12 col-sm-10 col-md-6 col-lg-4"
      *ngFor="let card of cardsData"
    >
      <div class="card h-100 border border-dark shadow bg-cover">
        <div class="card-body">
          <h5 class="card-title headingBS text-center">
            {{ card.title }} <span> {{ card.title2 }}</span>
          </h5>
          <p class="card-text vtext text-center">{{ card.content }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
